export default function IconArr() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="49" height="10" viewBox="0 0 49 10" fill="none">
            <path d="M0.5 9H48.5L33 1" stroke="#BDBDBD" />
        </svg>
    );
}
